
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeFilter: '',
      lineUpDom: null
    };
  },
  computed: {
    ...mapGetters({
      artists: 'settings/artists',
      festival: 'settings/festival'
    }),
    day1Artists() {
      return this.getFilteredArtists(this.festival.day1.artists.map((a) => a._ref));
    },
    day2Artists() {
      return this.getFilteredArtists(this.festival.day2.artists.map((a) => a._ref));
    }
  },
  mounted() {
    if (this.$route.query?.stage) {
      this.onArtistFiltered(this.$route.query?.stage);
    }
    this.lineUpDom = document.getElementById('line-up');
  },
  methods: {
    toggleEasterEgg() {
      this.$store.commit('ui/toggleEasterEgg', true);
    },
    onArtistFiltered(stage) {
      const parsedStage = this.convertToSlug(stage);
      if (parsedStage === this.activeFilter) {
        this.activeFilter = '';
        const query = {};

        // Reset query parameter to the current route
        this.$router.push({ path: this.$route.path, query });
        this.$store.commit('ui/setActiveFilter', null);
      } else {
        this.activeFilter = parsedStage;
        const query = { stage: parsedStage };
        this.$store.commit('ui/setActiveFilter', parsedStage);

        // Add the query parameter to the current route
        this.$router.push({ path: this.$route.path, query });
      }

      this.scrollToTop();
    },
    manageDatesDays(date) {
      const event = new Date(date);
      const options = { weekday: 'long' };
      return event.toLocaleDateString('de-DE', options);
    },
    /* receive a date as String (2023-07-22)
     @returns 2 first letter of the day and date in european format (Fr 22.07.2022) */
    manageDatesDaysAndDate(date) {
      const event = new Date(date);
      let day = { weekday: 'long' };
      day = event.toLocaleDateString('de-DE', day).slice(0, 2);

      let monthYear = { year: 'numeric', month: 'numeric', day: 'numeric' };
      monthYear = event.toLocaleDateString('de-DE', monthYear);

      return day + ' ' + monthYear;
    },
    getFilteredArtists(artistsRefs) {
      return [...artistsRefs.map((_ref) => this.artists.find((a) => a._id === _ref))];
    },
    scrollToTop() {
      setTimeout(() => this.lineUpDom.scrollIntoView({ behavior: 'smooth' }), 300);
    },
    convertToSlug(str) {
      return str.toLowerCase().replace(/\s+/g, '-');
    }
  }
};
